module.exports = __webpack_public_path__ + "img/mh3.45291d7b.jpg";